<template>
  <div class="default">
    <LogoWithTitle />
    <section class="section">
      <h1 class="title">
        <slot name="title" />
      </h1>
      <slot name="contents" />
    </section>
  </div>
</template>

<script>
import LogoWithTitle from '@/assets/logos/logo-with-title-color.svg'
export default {
  name: 'Default',
  components: {
    LogoWithTitle
  }
}
</script>
<style lang="scss" scoped>
.default {
  min-height: 100vh;
  padding: 25px;
  text-align: center;

  .title {
    font-size: 40px;
  }

  .section {
    padding-right: 0;
    padding-left: 0;
  }
}
</style>
